// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"backgroundItem_thumbnail__31V25","active":"backgroundItem_active__rivps","label":"backgroundItem_label__3dbmy","attrib":"backgroundItem_attrib__1-b7v"};